import React from 'react'
import { ProductScreenVisual } from './ProductScreenVisual'
import type { ScreenCard } from './landingContent'

type ScreensCopy = {
  screensTitle: string
  screensCopy: string
}

type ScreensSectionProps = {
  copy: ScreensCopy
  cards: ScreenCard[]
}

export const ScreensSection: React.FC<ScreensSectionProps> = ({ copy, cards }) => {
  return (
    <section id="screens" className="landing-section landing-section--muted">
      <div className="container stack-lg">
        <div className="landing-section-heading">
          <h2>{copy.screensTitle}</h2>
          <p>{copy.screensCopy}</p>
        </div>
        <div className="landing-screen-grid">
          {cards.map((card) => (
            <article key={card.title} className="landing-screen-card">
              <div className="landing-screen-card__chrome">
                <span />
                <span />
                <span />
              </div>
              <ProductScreenVisual variant={card.visualKey} compact className="landing-product-screen" />
              <div className="landing-screen-card__content">
                <h3>{card.title}</h3>
                <p>{card.subtitle}</p>
                <div className="landing-mini-table">
                  {card.chips.map((chip) => <span key={chip}>{chip}</span>)}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
